import React, {Fragment} from "react";
import Sidebar from "../../components/Sidebar";
import NsAccordion from "../../components/accordion/NsAccordion";
import ContenutoModelliArchivioController from "./components/marche/ContenutoMarcheArchivioController";

export default function ArchivioMarcheView({
                                               title,
                                               isMobile,
                                               getAlberoStruttura,
                                               marche,
                                               handlerRefreshMarche,
                                               tipoVeicolo,
                                           }) {

    return (
        <Fragment>
            <div className={"container-fluid pt-3"}>
                <Fragment>
                    <Sidebar
                        sidebarContent={() => {
                            return isMobile ?
                                <NsAccordion
                                    titolo={'Struttura kpi'}
                                    label={'fas fa-stream'}>
                                    {
                                        getAlberoStruttura()
                                    }
                                </NsAccordion>
                                : getAlberoStruttura()
                        }}
                    >
                        <h4 className={"text-center"}>{title}</h4>
                        <hr className={"dropdown-divider"}/>

                        {/* Info per richiesta documento */}
                        <div className="alert alert-info alert-dismissible fade show" role="alert">
                            <p>Il materiale è disponibile esclusivamente per la consultazione.</p>
                            <p>Su richiesta, è possibile ottenere una copia digitale dei documenti scrivendo
                                all’indirizzo <strong>archivio@registrofiat.it</strong>.</p>
                            <p>Il numero massimo di documenti richiedibili è fissato in <strong>10/anno per
                                socio</strong>.</p>
                            <button type="button" className="btn-close" data-bs-dismiss="alert"
                                    aria-label="Close"></button>
                        </div>

                        <ContenutoModelliArchivioController
                            marche={marche}
                            handlerRefreshMarche={handlerRefreshMarche}
                            tipoVeicolo={tipoVeicolo}
                        />
                    </Sidebar>
                </Fragment>
            </div>
        </Fragment>
    );
}